export default __webpack_public_path__ + "68667acfca985ff8aa2479cd18bedda9.png";